<template>
  <header class="qairn-generator-header">
    <h1 class="qairn-generator-heading">JSON Generator for Qairn</h1>
    <a href="./index.html">
      <img src="src/assets/qairn-logo.svg" width="192px" alt="Qairn logo">
    </a>
  </header>
</template>

<script>
export default {
}
</script>


// WEBPACK FOOTER //
// src/components/Header.vue